module.exports = __webpack_public_path__ + "static/media/Iconly-Light-Edit-Square.a93751be.svg";